import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Button, InputGroup, FormControl, Col, Row } from 'react-bootstrap'
import AuthService from "../../controllers/AuthService";
import UserService from "../../controllers/UserService";
import { Redirect } from 'react-router-dom'
import {Helmet} from "react-helmet";

const PasswordCreated = props => {

    return (
        <div>
            <Helmet>
                <title>สร้างรหัสผ่านแล้วสำหรับเข้าสู่พื้นที่ของการปรับใจ จิตวิทยาเชิงบวกเริ่มต้นได้ที่นี่ - Mindsetmaker.co</title>
                <meta property="og:title"       content="สร้างรหัสผ่านแล้วสำหรับเข้าสู่พื้นที่ของการปรับใจ จิตวิทยาเชิงบวกเริ่มต้นได้ที่นี่ - Mindsetmaker.co" />
                <meta property="og:description" content="สร้างรหัสผ่านแล้วสำหรับเข้าสู่ระบบกิจกรรมปรับใจสำหรับชั่วโมงโฮมรูม จิตวิทยาเชิงบวกเริ่มต้นได้ในห้องเรียน โดยนำ 24 อุปนิสัยเชิงบวกมาใช้ผ่านเรื่องราวแรงบันดาลใจทั่วโลก" />
            </Helmet>
            <Row>
                <Col className="text-center w-100 full-height">
                    <div className="login-page mx-3" align="center">
                        <h1 className="pt-4 pt-md-5 header primary-text">สร้างรหัสผ่านแล้ว</h1>
                        <h5 className="font-weight-normal font-sarabun line-height-26">รหัสผ่านถูกสร้างเรียบร้อยแล้ว โปรดเลือก <span className="doNotWrap">“เข้าสู่ระบบ”</span> เพื่อทำการใช้งานอีกครั้งค่ะ</h5>                       
                        <div className="login-form">                          
                            <div>
                                <a href="/login"><Button variant="primary" className="signin w-100  mt-lg-2" >เข้าสู่ระบบ</Button></a>
                            </div>
                           
                        </div>
                    </div>
                </Col>
            </Row>
        </div>
    );
};

export default PasswordCreated;